var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"px-1 py-0 text--blue",attrs:{"title":_vm.title},on:{"click":_vm.changeLocale}},[_vm._v(" "+_vm._s(_vm.locale.toUpperCase())+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }